import { KEYBOARD_INTERFACE_PREFIX } from '../../actionTypePrefixes';
import { addActionTypePrefix } from '../../util/addActionTypePrefix';

export const SET_NOTE_RANGE = addActionTypePrefix(
   'SET_NOTE_RANGE',
   KEYBOARD_INTERFACE_PREFIX
);
export const setNoteRange = (noteRange) => ({
   type: SET_NOTE_RANGE,
   noteRange,
});

export const SET_HIDDEN_CONTROLS = addActionTypePrefix(
   'SET_HIDDEN_CONTROLS',
   KEYBOARD_INTERFACE_PREFIX
);
export const setHiddenControls = (hiddenControls) => ({
   type: SET_HIDDEN_CONTROLS,
   hiddenControls,
});

export const SET_SELECTED_NOTES = addActionTypePrefix(
   'SET_SELECTED_NOTES',
   KEYBOARD_INTERFACE_PREFIX
);
export const setSelectedNotes = (notes) => ({
   type: SET_SELECTED_NOTES,
   notes,
});

export const SET_LABELED_NOTES = addActionTypePrefix(
   'SET_LABELED_NOTES',
   KEYBOARD_INTERFACE_PREFIX
);
export const setLabeledNotes = (notes) => ({
   type: SET_LABELED_NOTES,
   notes,
});

export const TOGGLE_NOTE_SELECTED = addActionTypePrefix(
   'TOGGLE_NOTE_SELECTED',
   KEYBOARD_INTERFACE_PREFIX
);
export const toggleNoteSelected = (note) => ({
   type: TOGGLE_NOTE_SELECTED,
   note,
});

export const CLEAR_SELECTED_NOTES = addActionTypePrefix(
   'CLEAR_SELECTED_NOTES',
   KEYBOARD_INTERFACE_PREFIX
);
export const clearSelectedNotes = () => ({
   type: CLEAR_SELECTED_NOTES,
});

export const SET_REFERENCE_NOTES = addActionTypePrefix(
   'SET_REFERENCE_NOTES',
   KEYBOARD_INTERFACE_PREFIX
);
export const setReferenceNotes = (notes) => ({
   type: SET_REFERENCE_NOTES,
   notes,
});

export const TOGGLE_REFERENCE_PLAYING = addActionTypePrefix(
   'TOGGLE_REFERENCE_PLAYING',
   KEYBOARD_INTERFACE_PREFIX
);
export const toggleReferencePlaying = () => ({
   type: TOGGLE_REFERENCE_PLAYING,
});

export const TOGGLE_SELECTED_PLAYING = addActionTypePrefix(
   'TOGGLE_SELECTED_PLAYING',
   KEYBOARD_INTERFACE_PREFIX
);
export const toggleSelectedPlaying = () => ({
   type: TOGGLE_SELECTED_PLAYING,
});

export const STOP_PLAYING = addActionTypePrefix(
   'STOP_PLAYING',
   KEYBOARD_INTERFACE_PREFIX
);
export const stopPlaying = (allowSustain) => ({
   type: STOP_PLAYING,
   allowSustain,
});

export const SET_CAN_PLAY_SELECTED_WITHOUT_COMPARE_ANSWER = addActionTypePrefix(
   'SET_CAN_PLAY_SELECTED_WITHOUT_COMPARE_ANSWER',
   KEYBOARD_INTERFACE_PREFIX
);
export const setCanPlaySelectedWithoutCompareAnswer = (
   canPlaySelectedWithoutCompareAnswer
) => ({
   type: SET_CAN_PLAY_SELECTED_WITHOUT_COMPARE_ANSWER,
   canPlaySelectedWithoutCompareAnswer,
});

export const PLAY_NOTES = addActionTypePrefix(
   'PLAY_NOTES',
   KEYBOARD_INTERFACE_PREFIX
);
export const playNotes = (notes, instrumentName) => ({
   type: PLAY_NOTES,
   notes,
   instrumentName,
});

// Pull this out?
export const DOCUMENT_KEYUP = 'DOCUMENT_KEYUP';
export const documentKeyUp = (code) => ({
   type: DOCUMENT_KEYUP,
   code,
});

// Pull this out?
export const DOCUMENT_KEYDOWN = 'DOCUMENT_KEYDOWN';
export const documentKeyDown = (code) => ({
   type: DOCUMENT_KEYDOWN,
   code,
});

export const PIANO_KEY_DOWN = addActionTypePrefix(
   'PIANO_KEY_DOWN',
   KEYBOARD_INTERFACE_PREFIX
);
export const pianoKeyDown = (note) => ({
   type: PIANO_KEY_DOWN,
   note,
});

export const PIANO_KEY_UP = addActionTypePrefix(
   'PIANO_KEY_UP',
   KEYBOARD_INTERFACE_PREFIX
);
export const pianoKeyUp = (note) => ({
   type: PIANO_KEY_UP,
   note,
});

export const PIANO_TOUCH_START = addActionTypePrefix(
   'PIANO_TOUCH_START',
   KEYBOARD_INTERFACE_PREFIX
);
export const pianoTouchStart = (x, y, button) => ({
   type: PIANO_TOUCH_START,
   x,
   y,
   mouseButton: button,
});

export const SET_VIEW = addActionTypePrefix(
   'SET_VIEW',
   KEYBOARD_INTERFACE_PREFIX
);
export const setView = (viewType) => ({
   type: SET_VIEW,
   viewType,
});
export const SET_CHORD_INFO = addActionTypePrefix(
   'SET_CHORD_INFO',
   KEYBOARD_INTERFACE_PREFIX
);
export const setChordInfo = (info) => ({
   type: SET_CHORD_INFO,
   info,
});

export const SELECT_CHORD_INFO_VALUE = addActionTypePrefix(
   'SELECT_CHORD_INFO_VALUE',
   KEYBOARD_INTERFACE_PREFIX
);
export const selectChordInfoValue = (key, value) => ({
   type: SELECT_CHORD_INFO_VALUE,
   key,
   value,
});
